var _require = require('humps'),
  pascalize = _require.pascalize;
import * as interactions from '@instructure/quiz-interactions';
var slugToNameMap = {
  'multi-answer': 'MultipleAnswer',
  choice: 'MultipleChoice'
};
var interactionTypeRecordForItem = function interactionTypeRecordForItem(intTypeSlug) {
  if (!intTypeSlug) {
    return interactions.InteractionType;
  }
  var componentKey = slugToNameMap[intTypeSlug];
  if (!componentKey) {
    componentKey = pascalize(intTypeSlug);
  }
  var recordName = "".concat(componentKey, "InteractionType");
  return interactions[recordName] || interactions.InteractionType;
};
export default interactionTypeRecordForItem;